module.exports = __webpack_public_path__ + "static/media/Rufus King - 1816.c2ad6f07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Rufus King - 1816.jpg
// module id = 545
// module chunks = 0